const KEY = "lw_cart";

export const getCart = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "[]");
  } catch {
    return [];
  }
};

export const saveCart = (items) => {
  localStorage.setItem(KEY, JSON.stringify(items));
  window.dispatchEvent(new Event("lw-cart"));
};

// stock null/undefined means the product isn't stock-tracked
const capQty = (qty, stock) => (stock == null ? qty : Math.min(qty, stock));

export const addToCart = (p) => {
  const items = getCart();
  const ex = items.find((i) => i.id === p.id);
  if (ex) {
    ex.stock = p.stock;
    ex.qty = capQty(ex.qty + 1, p.stock);
  } else items.push({ id: p.id, name: p.name, price: p.price, img: p.img, stock: p.stock, qty: capQty(1, p.stock) });
  saveCart(items.filter((i) => i.qty > 0));
};

export const setQty = (id, qty) => {
  const items = getCart()
    .map((i) => (i.id === id ? { ...i, qty: capQty(Math.max(0, qty), i.stock) } : i))
    .filter((i) => i.qty > 0);
  saveCart(items);
};

export const clearCart = () => saveCart([]);

export const cartCount = () => getCart().reduce((s, i) => s + i.qty, 0);
